<template>
  <sc-btn type="link" :handler="open" text="详情" />
</template>

<script lang="ts" setup>
import { computed, defineProps, shallowRef } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { windows } from '@/components/common/window/Windows';
import { HasManyFieldType } from '@/components/business/crud/interface/FieldType';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';

const props = defineProps<{
  propName: string;
  widget: HasManyFieldType;
  info: WidgetInfo;
  data: any;
}>();

function open() {
  windows.open({
    content: {
      type: 'component',
      component: shallowRef(HasMany),
      props: computed(() => {
        return {
          ...props,
          info: {
            ...props.info,
            status: 'edit',
          }
        }
      }),
    },
    title: props.info.title + '详情',
    width: 1280,
    height: 800,
    padding: 20,
  });
}
</script>

<script lang="ts">
import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { show: 'large' },
});
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
